export default __webpack_public_path__ + "static/media/cv.045e4bb2.svg";